import React from 'react';
import { Route } from 'react-router-dom';
import { Fade } from 'components/Animations';

export const AnimRoute = ({component, render, exact, path, computedMatch, location, ...otherProps})=>{
  return (
    <Fade in={true} appear={true} duration={100}>
      <Route path={path} exact={exact} component={component} render={render} />
    </Fade>
  );
};

export default AnimRoute;


// WEBPACK FOOTER //
// ./src/components/routes/AnimRoute.jsx